(function () {
  "use strict";

  const section = document.querySelector(".product-section");
  if (!section) return;

  const productPage = document.getElementById(
    "MainProduct-" +
      (section.querySelector("[data-section]")?.dataset?.section || "")
  );
  if (!productPage) return;

  const sectionId = productPage.dataset.section || "";
  const sliderEl = document.getElementById("product-media-slider-" + sectionId);
  const form = productPage.querySelector(".product-form");
  const variantInput = form ? form.querySelector('input[name="id"]') : null;

  function getProductData() {
    if (!productPage) return null;
    if (
      typeof window.productDataSection !== "undefined" &&
      window.productDataSection &&
      window.productDataSection.variants
    ) {
      return window.productDataSection;
    }
    var str = productPage.dataset.productData;
    if (!str) return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  let currentSlideIndex = 0;
  let visibleSlides = []; // after color filter, only visible slide elements
  let allSlides = [];
  let allThumbs = [];

  function getSlides() {
    if (!sliderEl) return [];
    return Array.from(
      sliderEl.querySelectorAll(".media-wrapper.gallery-slide")
    );
  }

  function getThumbs() {
    return Array.from(productPage.querySelectorAll(".thumbnail-item"));
  }

  function getVisibleSlides() {
    return getSlides().filter(function (s) {
      return !s.classList.contains("gallery-slide--hidden-by-color");
    });
  }

  function getVisibleThumbs() {
    return getThumbs().filter(function (t) {
      return !t.classList.contains("thumbnail-item--hidden-by-color");
    });
  }

  function updateSliderPosition(index) {
    if (!sliderEl) return;
    allSlides = getSlides();
    visibleSlides = getVisibleSlides();
    if (visibleSlides.length === 0) return;
    var idx = Math.max(0, Math.min(index, visibleSlides.length - 1));
    currentSlideIndex = idx;
    var targetSlide = visibleSlides[idx];
    /* When color filter hides slides (display:none), only visible slides are in the flex layout.
       So we translate by visible index (currentSlideIndex), not index in full list. */
    var translatePercent = currentSlideIndex * 100;
    sliderEl.style.transition = "none";
    sliderEl.style.transform = "translateX(-" + translatePercent + "%)";
    updateThumbnailActive();
    updateVideoState();
  }

  function scrollThumbIntoView(thumb, behavior) {
    if (!thumb) return;
    var container = thumb.closest(".thumbnail-bar-inner");
    if (!container) return;
    var thumbLeft = thumb.offsetLeft;
    var thumbWidth = thumb.offsetWidth;
    var containerWidth = container.clientWidth;
    var scrollTarget = thumbLeft - containerWidth / 2 + thumbWidth / 2;
    scrollTarget = Math.max(
      0,
      Math.min(scrollTarget, container.scrollWidth - containerWidth)
    );
    container.scrollTo({ left: scrollTarget, behavior: behavior || "smooth" });
  }

  function updateThumbnailActive() {
    allThumbs = getThumbs();
    visibleSlides = getVisibleSlides();
    var targetSlide = visibleSlides[currentSlideIndex];
    if (!targetSlide) return;
    var dataIndex = targetSlide.getAttribute("data-media-index");
    allThumbs.forEach(function (thumb) {
      thumb.classList.toggle(
        "active",
        thumb.getAttribute("data-thumb-index") === dataIndex &&
          !thumb.classList.contains("thumbnail-item--hidden-by-color")
      );
    });
    var mainBar = productPage.querySelector(
      ".thumbnail-bar:not(.thumbnail-bar--fullscreen)"
    );
    if (mainBar) {
      var activeThumb = mainBar.querySelector(".thumbnail-item.active");
      scrollThumbIntoView(activeThumb, "smooth");
    }
  }

  function goPrev() {
    visibleSlides = getVisibleSlides();
    if (visibleSlides.length === 0) return;
    var next =
      (currentSlideIndex - 1 + visibleSlides.length) % visibleSlides.length;
    updateSliderPosition(next);
  }

  function goNext() {
    visibleSlides = getVisibleSlides();
    if (visibleSlides.length === 0) return;
    var next = (currentSlideIndex + 1) % visibleSlides.length;
    updateSliderPosition(next);
  }

  function normalizeForColorMatch(str) {
    if (typeof str !== "string" || !str.trim()) return "";
    return str
      .toLowerCase()
      .trim()
      .replace(/\s*\/\s*/g, "-")
      .replace(/\//g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function getColorFilterConfig() {
    var idx = productPage.dataset.colorOptionIndex;
    var vals = productPage.dataset.colorValues;
    if (idx === undefined || idx === "" || vals === undefined || vals === "")
      return null;
    var colorIndex = parseInt(idx, 10);
    if (isNaN(colorIndex) || colorIndex < 0) return null;
    try {
      var values = JSON.parse(vals);
      if (!Array.isArray(values) || values.length < 2) return null;
      return { index: colorIndex, values: values };
    } catch (e) {
      return null;
    }
  }

  function slideVisibleForColor(
    slide,
    selectedColorNormalized,
    normalizedColorList
  ) {
    var alt = (slide.dataset.mediaAlt || "").trim();
    if (!alt) return true;
    var normalizedAlt = normalizeForColorMatch(alt);
    if (!normalizedAlt) return true;
    for (var i = 0; i < normalizedColorList.length; i++) {
      var n = normalizedColorList[i].normalized;
      if (n && normalizedAlt.indexOf(n) !== -1) {
        return n === selectedColorNormalized;
      }
    }
    return true;
  }

  function filterGalleryByColor(selectedColor) {
    allSlides = getSlides();
    allThumbs = getThumbs();
    var config = getColorFilterConfig();
    var hiddenClassSlide = "gallery-slide--hidden-by-color";
    var hiddenClassThumb = "thumbnail-item--hidden-by-color";

    // var isNone = selectedColor && String(selectedColor).trim().toLowerCase() === "none";
    // if (!config || !selectedColor || !selectedColor.trim() || isNone) {
    if (!config || !selectedColor || !selectedColor.trim()) {
      allSlides.forEach(function (s) {
        s.classList.remove(hiddenClassSlide);
      });
      allThumbs.forEach(function (t) {
        t.classList.remove(hiddenClassThumb);
      });
      visibleSlides = getVisibleSlides();
      updateSliderPosition(0);
      return;
    }

    var selectedColorNormalized = normalizeForColorMatch(selectedColor);
    var normalizedColorList = config.values
      .map(function (v) {
        return { value: v, normalized: normalizeForColorMatch(String(v)) };
      })
      .filter(function (o) {
        return o.normalized;
      })
      .sort(function (a, b) {
        return b.normalized.length - a.normalized.length;
      });

    allSlides.forEach(function (slide) {
      var visible = slideVisibleForColor(
        slide,
        selectedColorNormalized,
        normalizedColorList
      );
      if (visible) {
        slide.classList.remove(hiddenClassSlide);
      } else {
        slide.classList.add(hiddenClassSlide);
      }
    });

    allThumbs.forEach(function (thumb) {
      var mediaAlt = (thumb.dataset.mediaAlt || "").trim();
      if (!mediaAlt) {
        thumb.classList.remove(hiddenClassThumb);
        return;
      }
      var normalizedAlt = normalizeForColorMatch(mediaAlt);
      if (!normalizedAlt) {
        thumb.classList.remove(hiddenClassThumb);
        return;
      }
      var assigned = null;
      for (var j = 0; j < normalizedColorList.length; j++) {
        if (
          normalizedColorList[j].normalized &&
          normalizedAlt.indexOf(normalizedColorList[j].normalized) !== -1
        ) {
          assigned = normalizedColorList[j].normalized;
          break;
        }
      }
      if (assigned === null) {
        thumb.classList.remove(hiddenClassThumb);
      } else {
        thumb.classList.toggle(
          hiddenClassThumb,
          assigned !== selectedColorNormalized
        );
      }
    });

    visibleSlides = getVisibleSlides();
    updateSliderPosition(0);
  }

  function applyColorFilterFromVariant(variant) {
    var config = getColorFilterConfig();
    if (!config) {
      filterGalleryByColor(null);
      return;
    }
    var selectedColor = null;
    var opts =
      variant &&
      (variant.options ||
        [variant.option1, variant.option2, variant.option3].filter(Boolean));
    if (variant && opts && opts[config.index] !== undefined) {
      selectedColor = opts[config.index];
    } else {
      var checked = productPage.querySelector(
        '.variant-option-input[data-option-index="' +
          config.index +
          '"]:checked'
      );
      if (checked) selectedColor = checked.value;
    }
    // var isNone =
    //   selectedColor && String(selectedColor).trim().toLowerCase() === "none";
    // filterGalleryByColor(isNone ? null : selectedColor || null);
    filterGalleryByColor(selectedColor || null);
  }

  function updateVideoState() {
    allSlides = getSlides();
    visibleSlides = getVisibleSlides();
    var currentSlide = visibleSlides[currentSlideIndex];
    allSlides.forEach(function (slide) {
      var video = slide.querySelector("video");
      if (!video) return;
      if (slide === currentSlide) {
        video.pause();
        video.currentTime = 0.1;
      } else {
        video.pause();
      }
    });
  }

  function setupVideoObserver() {
    var videos = productPage.querySelectorAll(".gallery-slide--video video");
    videos.forEach(function (video) {
      var slide = video.closest(".media-wrapper");
      if (!slide) return;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visibleSlides = getVisibleSlides();
            var isActive = visibleSlides[currentSlideIndex] === slide;
            if (entry.isIntersecting && isActive) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        {
          threshold: 0.25,
          root: (sliderEl && sliderEl.closest(".gallery-slider-area")) || null,
        }
      );
      observer.observe(slide);
    });
  }

  function getSelectedOptions() {
    var data = getProductData();
    var optionCount =
      data && data.options && data.options.length ? data.options.length : 3;
    var opts = [];
    for (var i = 0; i < optionCount; i++) opts[i] = null;
    productPage
      .querySelectorAll(".variant-option-input:checked")
      .forEach(function (input) {
        var idx = parseInt(input.getAttribute("data-option-index"), 10);
        if (!isNaN(idx) && idx >= 0 && idx < optionCount)
          opts[idx] = input.value;
      });
    return opts;
  }

  function findVariantByOptions(options) {
    var data = getProductData();
    if (!data || !data.variants) return null;
    return data.variants.find(function (v) {
      var o1 = v.option1 || (v.options && v.options[0]);
      var o2 = v.option2 || (v.options && v.options[1]);
      var o3 = v.option3 || (v.options && v.options[2]);
      var match0 = options[0] == null || options[0] === o1;
      var match1 = options[1] == null || options[1] === o2;
      var match2 = options[2] == null || options[2] === o3;
      return match0 && match1 && match2;
    });
  }

  function updatePrices(variant) {
    if (!variant) return;
    var priceBlock =
      productPage.querySelector("[data-product-price-block]") ||
      productPage.querySelector(".product-block--price");
    var currentPrice = priceBlock
      ? priceBlock.querySelector("[data-product-current-price], .current-price")
      : productPage.querySelector(
          "[data-product-current-price], .current-price"
        );
    var comparePrice = priceBlock
      ? priceBlock.querySelector("[data-product-compare-price], .compare-price")
      : productPage.querySelector(
          "[data-product-compare-price], .compare-price"
        );
    var savingsEl = priceBlock
      ? priceBlock.querySelector("[data-product-savings], .savings")
      : productPage.querySelector("[data-product-savings], .savings");
    if (!currentPrice) return;
    var priceCents = variant.price != null ? Number(variant.price) : 0;
    var compareCents =
      variant.compare_at_price != null ? Number(variant.compare_at_price) : 0;
    var moneyFormat =
      window.Shopify && window.Shopify.formatMoney ? Shopify.formatMoney : null;
    var format =
      window.money_without_trailing_zeros_format || window.money_format;
    var formatPrice = function (cents) {
      var c = Number(cents);
      if (isNaN(c)) return "";
      if (moneyFormat) {
        var str =
          typeof format === "string" ? moneyFormat(c, format) : moneyFormat(c);
        if (typeof str === "string")
          str = str
            .replace(/\.0+$/, "")
            .replace(/(\.\d*[1-9])0+$/, "$1")
            .replace(/\.$/, "");
        return str;
      }
      var s = (c / 100).toFixed(2).replace(/\.?0+$/, "");
      return "$" + (s || "0");
    };
    currentPrice.textContent = formatPrice(priceCents);
    if (comparePrice) comparePrice.textContent = formatPrice(compareCents);
    if (compareCents > priceCents) {
      var saveAmount = compareCents - priceCents;
      if (savingsEl) {
        savingsEl.textContent = "Save" + " " + formatPrice(saveAmount);
        savingsEl.style.display = "";
      }
      if (comparePrice) comparePrice.style.display = "";
    } else {
      if (comparePrice) comparePrice.style.display = "none";
      if (savingsEl) savingsEl.style.display = "none";
    }
  }

  function removeVariantSectionLoading() {
    var wrapper = productPage.querySelector(".variant-selector-wrapper");
    if (wrapper) wrapper.classList.remove("variant-selector-wrapper--loading");
  }

  function updateOptionButtonImages() {
    var data = getProductData();
    var optionCount =
      data && data.options && data.options.length ? data.options.length : 3;
    var grids = productPage.querySelectorAll('.option-buttons-grid[data-option-image-source="variant"]');
    if (grids.length === 0) {
      removeVariantSectionLoading();
      return;
    }
    var totalPending = 0;
    var completed = 0;
    grids.forEach(function (grid) {
      totalPending += grid.querySelectorAll(".option-button-wrap").length;
    });
    function oneDone() {
      completed++;
      if (completed >= totalPending) removeVariantSectionLoading();
    }
    productPage
      .querySelectorAll('.option-buttons-grid[data-option-image-source="variant"]')
      .forEach(function (grid) {
        var firstInput = grid.querySelector(".variant-option-input");
        var optionIndex =
          firstInput !== null
            ? parseInt(firstInput.getAttribute("data-option-index"), 10)
            : -1;
        if (isNaN(optionIndex) || optionIndex < 0) return;
        var currentOpts = getSelectedOptions();
        var wraps = grid.querySelectorAll(".option-button-wrap");
        wraps.forEach(function (wrap) {
          wrap.classList.add("option-button-wrap--loading");
        });
        wraps.forEach(function (wrap) {
          var input = wrap.querySelector(".variant-option-input");
          var value = input ? input.value : null;
          if (value == null) {
            wrap.classList.remove("option-button-wrap--loading");
            oneDone();
            return;
          }
          var opts = [];
          for (var i = 0; i < optionCount; i++)
            opts[i] = i === optionIndex ? value : currentOpts[i];
          var v = findVariantByOptions(opts);
          var img = wrap.querySelector(".option-button-img");
          if (!img) {
            wrap.classList.remove("option-button-wrap--loading");
            oneDone();
            return;
          }
          var imgSrc = null;
          var imgAlt = value;
          if (v) {
            if (v.featured_image && v.featured_image.src) {
              imgSrc = v.featured_image.src.split("?")[0] + "?width=288";
              if (v.featured_image.alt && String(v.featured_image.alt).trim())
                imgAlt = v.featured_image.alt;
            } else if (
              v.featured_media &&
              v.featured_media.preview_image &&
              v.featured_media.preview_image.src
            ) {
              imgSrc =
                v.featured_media.preview_image.src.split("?")[0] + "?width=288";
              if (v.featured_media.alt && String(v.featured_media.alt).trim())
                imgAlt = v.featured_media.alt;
            }
          }
          function removeLoading() {
            wrap.classList.remove("option-button-wrap--loading");
            img.onload = null;
            img.onerror = null;
            oneDone();
          }
          if (imgSrc) {
            img.onload = removeLoading;
            img.onerror = removeLoading;
            img.src = imgSrc;
            img.alt = imgAlt;
            img.style.display = "";
          } else {
            img.style.display = "none";
            wrap.classList.remove("option-button-wrap--loading");
            oneDone();
          }
        });
      });
  }

  function updateVariant(variant) {
    if (!variant) return;
    var wrapper = productPage.querySelector(".variant-selector-wrapper");
    if (wrapper) wrapper.classList.add("variant-selector-wrapper--loading");
    var allIdInputs = productPage.querySelectorAll('input[name="id"]');
    allIdInputs.forEach(function (inp) {
      inp.value = variant.id;
    });
    if (typeof window.history !== "undefined" && variant.id) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }
    updatePrices(variant);
    var submitBtn = productPage.querySelector(
      ".add-to-cart-btn:not(.request-call-trigger)"
    );
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? "Add to cart" : "Sold out";
    }
    applyColorFilterFromVariant(variant);
    updateOptionButtonImages();
  }

  function initGallery() {
    allSlides = getSlides();
    allThumbs = getThumbs();
    visibleSlides = getVisibleSlides();
    if (visibleSlides.length > 0) updateSliderPosition(0);

    var prevBtn = productPage.querySelector(".gallery-slider-prev");
    var nextBtn = productPage.querySelector(".gallery-slider-next");
    if (prevBtn) prevBtn.addEventListener("click", goPrev);
    if (nextBtn) nextBtn.addEventListener("click", goNext);

    allThumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var idx = thumb.getAttribute("data-thumb-index");
        if (idx == null) return;
        visibleSlides = getVisibleSlides();
        var found = visibleSlides.findIndex(function (s) {
          return s.getAttribute("data-media-index") === idx;
        });
        if (found >= 0) updateSliderPosition(found);
      });
    });

    var thumbPrev = productPage.querySelector(".thumbnail-arrow-prev");
    var thumbNext = productPage.querySelector(".thumbnail-arrow-next");
    if (thumbPrev) thumbPrev.addEventListener("click", goPrev);
    if (thumbNext) thumbNext.addEventListener("click", goNext);

    setupVideoObserver();
    initFullscreenGallery();
  }

  var fullscreenPopup = null;
  var fullscreenSliderEl = null;
  var currentSlideIndexFullscreen = 0;

  function getFullscreenSlides() {
    if (!fullscreenSliderEl) return [];
    return Array.from(
      fullscreenSliderEl.querySelectorAll(
        ".media-wrapper.gallery-fullscreen-slide"
      )
    );
  }

  function getFullscreenThumbs() {
    return Array.from(
      productPage.querySelectorAll(".thumbnail-fullscreen-item")
    );
  }

  function getVisibleFullscreenSlides() {
    return getFullscreenSlides().filter(function (s) {
      return !s.classList.contains("gallery-slide--hidden-by-color");
    });
  }

  function updateFullscreenSliderPosition(index) {
    if (!fullscreenSliderEl) return;
    var fsSlides = getFullscreenSlides();
    var visibleFs = getVisibleFullscreenSlides();
    if (visibleFs.length === 0) return;
    var idx = Math.max(0, Math.min(index, visibleFs.length - 1));
    currentSlideIndexFullscreen = idx;
    var translatePercent = currentSlideIndexFullscreen * 100;
    fullscreenSliderEl.style.transition = "none";
    fullscreenSliderEl.style.transform =
      "translateX(-" + translatePercent + "%)";
    var targetSlide = visibleFs[idx];
    var dataIndex = targetSlide
      ? targetSlide.getAttribute("data-media-index")
      : null;
    getFullscreenThumbs().forEach(function (t) {
      t.classList.toggle(
        "active",
        t.getAttribute("data-thumb-index") === dataIndex &&
          !t.classList.contains("thumbnail-item--hidden-by-color")
      );
    });
  }

  function syncFullscreenFromMain() {
    allSlides = getSlides();
    allThumbs = getThumbs();
    visibleSlides = getVisibleSlides();
    var fsSlides = getFullscreenSlides();
    var fsThumbs = getFullscreenThumbs();
    var hiddenClassSlide = "gallery-slide--hidden-by-color";
    var hiddenClassThumb = "thumbnail-item--hidden-by-color";
    allSlides.forEach(function (slide) {
      var mid = slide.getAttribute("data-media-index");
      var fsSlide = fsSlides.find(function (s) {
        return s.getAttribute("data-media-index") === mid;
      });
      if (fsSlide) {
        if (slide.classList.contains(hiddenClassSlide))
          fsSlide.classList.add(hiddenClassSlide);
        else fsSlide.classList.remove(hiddenClassSlide);
      }
    });
    allThumbs.forEach(function (thumb) {
      var tid = thumb.getAttribute("data-thumb-index");
      var fsThumb = fsThumbs.find(function (t) {
        return t.getAttribute("data-thumb-index") === tid;
      });
      if (fsThumb) {
        if (thumb.classList.contains(hiddenClassThumb))
          fsThumb.classList.add(hiddenClassThumb);
        else fsThumb.classList.remove(hiddenClassThumb);
      }
    });
    currentSlideIndexFullscreen = currentSlideIndex;
    updateFullscreenSliderPosition(currentSlideIndexFullscreen);
  }

  function fullscreenGoPrev() {
    var visibleFs = getVisibleFullscreenSlides();
    if (visibleFs.length === 0) return;
    var next =
      (currentSlideIndexFullscreen - 1 + visibleFs.length) % visibleFs.length;
    updateFullscreenSliderPosition(next);
  }

  function fullscreenGoNext() {
    var visibleFs = getVisibleFullscreenSlides();
    if (visibleFs.length === 0) return;
    var next = (currentSlideIndexFullscreen + 1) % visibleFs.length;
    updateFullscreenSliderPosition(next);
  }

  function openFullscreen() {
    if (!fullscreenPopup) return;
    fullscreenPopup.classList.add("is-open");
    fullscreenPopup.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    syncFullscreenFromMain();
  }

  function closeFullscreen() {
    if (!fullscreenPopup) return;
    fullscreenPopup.classList.remove("is-open");
    fullscreenPopup.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function initFullscreenGallery() {
    fullscreenPopup = productPage.querySelector("[data-gallery-fullscreen]");
    fullscreenSliderEl = document.getElementById(
      "product-media-slider-fullscreen-" + sectionId
    );
    if (!fullscreenPopup || !fullscreenSliderEl) return;

    var extendBtn = productPage.querySelector("[data-gallery-extend]");
    if (extendBtn) {
      extendBtn.addEventListener("click", function () {
        this.classList.add("blink");
        var self = this;
        setTimeout(function () {
          self.classList.remove("blink");
        }, 450);
        openFullscreen();
      });
    }

    var closeButtons = productPage.querySelectorAll(
      "[data-gallery-fullscreen-close]"
    );
    closeButtons.forEach(function (btn) {
      btn.addEventListener("click", closeFullscreen);
    });

    document.addEventListener("keydown", function (e) {
      if (
        e.key === "Escape" &&
        fullscreenPopup &&
        fullscreenPopup.classList.contains("is-open")
      ) {
        closeFullscreen();
      }
    });

    var fsPrev = productPage.querySelector(".gallery-fullscreen-prev");
    var fsNext = productPage.querySelector(".gallery-fullscreen-next");
    if (fsPrev) fsPrev.addEventListener("click", fullscreenGoPrev);
    if (fsNext) fsNext.addEventListener("click", fullscreenGoNext);

    getFullscreenThumbs().forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var idx = thumb.getAttribute("data-thumb-index");
        if (idx == null) return;
        var visibleFs = getVisibleFullscreenSlides();
        var found = visibleFs.findIndex(function (s) {
          return s.getAttribute("data-media-index") === idx;
        });
        if (found >= 0) updateFullscreenSliderPosition(found);
      });
    });

    var fsThumbPrev = productPage.querySelector(".thumbnail-fullscreen-prev");
    var fsThumbNext = productPage.querySelector(".thumbnail-fullscreen-next");
    if (fsThumbPrev) fsThumbPrev.addEventListener("click", fullscreenGoPrev);
    if (fsThumbNext) fsThumbNext.addEventListener("click", fullscreenGoNext);
  }

  function updateNoneColorButtonState() {
    var wrapper = productPage.querySelector("[data-cant-decide-wrapper]");
    if (!wrapper) return;
    var btn = wrapper.querySelector("[data-none-color-select]");
    if (!btn) return;
    var colorIndex = parseInt(
      wrapper.getAttribute("data-color-option-index"),
      10
    );
    var noneValue = wrapper.getAttribute("data-none-value") || "None";
    var opts = getSelectedOptions();
    var isNone = opts[colorIndex] === noneValue;
    btn.classList.toggle("is-checked", isNone);
    btn.setAttribute("aria-pressed", isNone ? "true" : "false");
  }

  function handleVariantChange(input) {
    if (!input || !input.classList.contains("variant-option-input")) return;
    productPage.querySelectorAll(".product-swatch").forEach(function (l) {
      l.classList.remove("product-swatch--selected");
    });
    productPage.querySelectorAll(".option-button-label").forEach(function (l) {
      l.classList.remove("option-button-label--active");
    });
    productPage
      .querySelectorAll(".variant-option-input:checked")
      .forEach(function (checkedInput) {
        var label = productPage.querySelector(
          'label[for="' + checkedInput.id + '"]'
        );
        if (label) {
          if (label.classList.contains("product-swatch"))
            label.classList.add("product-swatch--selected");
          if (label.classList.contains("option-button-label"))
            label.classList.add("option-button-label--active");
        }
      });
    var variant = findVariantByOptions(getSelectedOptions());
    if (variant) updateVariant(variant);
    updateNoneColorButtonState();
  }

  function initVariants() {
    var variantWrapper =
      productPage.querySelector(
        ".variant-selector-wrapper, .product-variants-accordion"
      ) || productPage;
    variantWrapper.addEventListener("change", function (e) {
      if (e.target && e.target.classList.contains("variant-option-input")) {
        handleVariantChange(e.target);
      }
    });
    productPage
      .querySelectorAll(".product-swatch, .option-button-label")
      .forEach(function (label) {
        label.addEventListener("click", function (e) {
          e.preventDefault();
          var forId = label.getAttribute("for");
          if (!forId) return;
          var input = document.getElementById(forId);
          if (input && input.classList.contains("variant-option-input")) {
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });
    var noneSelectBtn = productPage.querySelector("[data-none-color-select]");
    if (noneSelectBtn) {
      noneSelectBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var input = productPage.querySelector("input[data-none-color-input]");
        if (input && input.classList.contains("variant-option-input")) {
          input.checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      updateNoneColorButtonState();
    }
    updateOptionButtonImages();
  }

  function initForm() {
    if (!productPage) return;
    var triggerBtn = productPage.querySelector("[data-add-to-cart]");

    // Quantity selector (guard against re-init on variant change)
    var qtyWrap = productPage.querySelector("[data-product-qty]");
    if (qtyWrap && !qtyWrap.dataset.qtyInit) {
      qtyWrap.dataset.qtyInit = "1";
      var qInput = qtyWrap.querySelector("[data-qty-input]");
      var qMinus = qtyWrap.querySelector("[data-qty-minus]");
      var qPlus = qtyWrap.querySelector("[data-qty-plus]");
      var clampQty = function () {
        var v = parseInt(qInput.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        qInput.value = v;
      };
      if (qMinus)
        qMinus.addEventListener("click", function () {
          qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) - 1);
        });
      if (qPlus)
        qPlus.addEventListener("click", function () {
          qInput.value = (parseInt(qInput.value, 10) || 1) + 1;
        });
      if (qInput) {
        qInput.addEventListener("change", clampQty);
        qInput.addEventListener("blur", clampQty);
      }
    }

    // Kept for reuse by the request-call popup (future dedicated section).
    window.getRequestCallBodyProductLine = function () {
      var variant = findVariantByOptions(getSelectedOptions());
      var productData = getProductData();
      var productTitle =
        productData && productData.title ? productData.title : "";
      var variantLabel = "";
      if (variant && (variant.option1 || variant.option2 || variant.option3)) {
        var opts = [variant.option1, variant.option2, variant.option3].filter(
          Boolean
        );
        variantLabel = opts.join("/");
      }
      var productSelection =
        productTitle + (variantLabel ? " - " + variantLabel : "");
      return productSelection ? "Product: " + productSelection : "";
    };

    if (triggerBtn) {
      triggerBtn.addEventListener("click", function () {
        if (triggerBtn.disabled) return;
        var variantInputEl = productPage.querySelector(
          '.product-form input[name="id"]'
        );
        var mainVariantId = variantInputEl ? variantInputEl.value : null;
        if (!mainVariantId) return;

        // Include any upgrades staged via the upgrade drawer.
        var upgradeInputs = document.querySelectorAll(
          '[data-upsell-variant-input][data-has-value="true"]'
        );
        var qtyInputEl = productPage.querySelector("[data-qty-input]");
        var mainQty = qtyInputEl
          ? Math.max(1, parseInt(qtyInputEl.value, 10) || 1)
          : 1;
        var items = [{ id: mainVariantId, quantity: mainQty }];
        upgradeInputs.forEach(function (inp) {
          var val = inp.value ? inp.value.trim() : "";
          if (val) items.push({ id: val, quantity: 1 });
        });

        triggerBtn.disabled = true;
        var prevText = triggerBtn.textContent;
        triggerBtn.textContent = "Adding...";
        var checkedUpsellButtons = [];
        upgradeInputs.forEach(function (inp) {
          var wrap = inp.closest(".product-upsell__item-wrap");
          var btn = wrap
            ? wrap.querySelector("[data-upgrade-drawer-trigger]")
            : null;
          if (btn) {
            btn.classList.add("product-upsell__item--loading");
            checkedUpsellButtons.push(btn);
          }
        });

        fetch(
          (window.routes && window.routes.cart_add_url
            ? window.routes.cart_add_url
            : "/cart/add") + ".js",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          }
        )
          .then(function (r) {
            return r.json().then(function (data) {
              return { ok: r.ok, data: data };
            });
          })
          .then(function (res) {
            if (!res.ok) {
              throw new Error(
                (res.data && res.data.description) || "Unable to add to cart"
              );
            }
            // Notify the cart drawer (kaleido) to refresh count/contents.
            if (
              typeof publish === "function" &&
              typeof PUB_SUB_EVENTS !== "undefined"
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                action: "add",
                variant: res.data,
                source: "product-form",
              });
            }
            triggerBtn.textContent = "Added!";
            if (typeof window.openCartDrawer === "function") {
              window.openCartDrawer();
            }
            setTimeout(function () {
              triggerBtn.textContent = prevText;
              triggerBtn.disabled = false;
            }, 1200);
          })
          .catch(function (err) {
            if (
              typeof publish === "function" &&
              typeof PUB_SUB_EVENTS !== "undefined"
            ) {
              publish(PUB_SUB_EVENTS.cartError, {
                error: err.message,
                context: "product-form-add",
              });
            }
            triggerBtn.textContent = "Error - Try Again";
            setTimeout(function () {
              triggerBtn.textContent = prevText;
              triggerBtn.disabled = false;
            }, 2000);
          })
          .finally(function () {
            checkedUpsellButtons.forEach(function (btn) {
              btn.classList.remove("product-upsell__item--loading");
            });
          });
      });
    }
  }

  function checkUrlVariant() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get("variant");
    var productData = getProductData();
    if (variantId && productData && productData.variants) {
      var v = productData.variants.find(function (x) {
        return String(x.id) === String(variantId);
      });
      if (v) {
        updateVariant(v);
        var vOpt1 = v.option1;
        var vOpt2 = v.option2;
        var vOpt3 = v.option3;
        productPage
          .querySelectorAll(".variant-option-input")
          .forEach(function (input) {
            var idx = parseInt(input.getAttribute("data-option-index"), 10);
            if (isNaN(idx)) return;
            var match =
              (idx === 0 && vOpt1 === input.value) ||
              (idx === 1 && vOpt2 === input.value) ||
              (idx === 2 && vOpt3 === input.value);
            if (match) input.checked = true;
          });
        productPage
          .querySelectorAll(".product-swatch--selected")
          .forEach(function (l) {
            l.classList.remove("product-swatch--selected");
          });
        productPage
          .querySelectorAll(".option-button-label--active")
          .forEach(function (l) {
            l.classList.remove("option-button-label--active");
          });
        productPage
          .querySelectorAll(".variant-option-input:checked")
          .forEach(function (input) {
            var label = productPage.querySelector(
              'label[for="' + input.id + '"]'
            );
            if (label) {
              if (label.classList.contains("product-swatch"))
                label.classList.add("product-swatch--selected");
              if (label.classList.contains("option-button-label"))
                label.classList.add("option-button-label--active");
            }
          });
        return;
      }
    }
    var current =
      (productData && productData.selected_or_first_available_variant) ||
      (productData && productData.variants && productData.variants[0]);
    if (current) updateVariant(current);
  }

  function syncInitialPrice() {
    var productData = getProductData();
    if (!productData || !productData.variants) return;
    var variantId = variantInput ? variantInput.value : null;
    var variant = variantId
      ? productData.variants.find(function (v) {
          return String(v.id) === String(variantId);
        })
      : productData.selected_or_first_available_variant ||
        productData.variants[0];
    if (variant) updatePrices(variant);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initGallery();
      initVariants();
      initForm();
      checkUrlVariant();
      requestAnimationFrame(function () {
        syncInitialPrice();
      });
    });
  } else {
    initGallery();
    initVariants();
    initForm();
    checkUrlVariant();
    requestAnimationFrame(function () {
      syncInitialPrice();
    });
  }
})();
